<h3 style="text-align: center; margin-top: 50px;">M.R. Subscription plans for Booking</h3>
<!-- <hr> -->
<div class="pricing-table">
    <div class="pricing-plan">
      <h2>Free</h2><hr>
      <!-- <p class="price">$10/month</p> -->
      <ul class="features">
        <li>50 Appointment</li>
        <li>1 Month</li>
        <li>contains ads</li>
      </ul>
      <!-- <button class="btn">Select Plan</button> -->
    </div>

    <div class="pricing-plan">
      <h2>M.R.</h2><hr>
      <p class="price">25/month</p>
      <ul class="features">
        <li>150 Appointments</li>
        <li>Uninterrupted service</li>
        <li>Without adds</li>
      </ul>
      <button class="btn">Select Plan</button>
    </div>

    <div class="pricing-plan">
      <h2>Company</h2><hr>
      <p class="price">50/person</p>
      <ul class="features">
        <li>150 appointments</li>
        <li>Uninterrupted service</li>
        <li>For Companies Only</li>
      </ul>
      <button class="btn">Select Plan</button>
    </div>
  </div>
  <!-- width 280
  height 360
  box shadow 0 3 6 1 silver
  border -radiues 25px -->